import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=3faa8b7a&scoped=true"
import script from "./BlankView.vue?vue&type=script&lang=js"
export * from "./BlankView.vue?vue&type=script&lang=js"
import style0 from "./BlankView.vue?vue&type=style&index=0&id=3faa8b7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa8b7a",
  null
  
)

export default component.exports